import posthog from 'posthog-js';
import { posthogConfig } from './config';

export type ReportType = 'metabase' | 'powerbi' | 'realtime';

export interface ReportViewedProps {
  report_id: string;
  report_name: string;
  report_url: string;
  report_type: ReportType;
  business_units: string[];
}

let initialized = false;
let identifiedFingerprint = '';

export const initAnalytics = () => {
  const { enabled, apiKey, apiHost } = posthogConfig;
  if (initialized || !enabled || !apiKey) {
    return;
  }

  try {
    posthog.init(apiKey, {
      api_host: apiHost,
      person_profiles: 'identified_only',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      capture_dead_clicks: false,
      capture_heatmaps: false,
      capture_exceptions: false,
      capture_performance: false,
      disable_surveys: true,
      disable_session_recording: true,
    });
    initialized = true;
  } catch {
    initialized = false;
  }
};

export const identifyUser = (userId: string, properties: { businessUnits: string[] }) => {
  if (!initialized) {
    return;
  }

  const fingerprint = JSON.stringify([userId, [...properties.businessUnits].sort()]);
  if (fingerprint === identifiedFingerprint) {
    return;
  }

  try {
    if (properties.businessUnits.length > 0) {
      posthog.identify(userId, { business_units: properties.businessUnits });
    } else {
      posthog.identify(userId);
    }
    identifiedFingerprint = fingerprint;
  } catch {
    return;
  }
};

export const trackReportViewed = (props: ReportViewedProps) => {
  if (!initialized) {
    return;
  }

  try {
    posthog.capture('report_viewed', props);
  } catch {
    return;
  }
};
